<template>
  <div />
</template>

<script>
import asControl from "@/components/mapbox/mixins/asControl";
import {
  mapIcons,
  createSvgIcon,
  createDisabledIcon,
} from "@/assets/icons/mapIcons";

export default {
  name: "FoulingToggleControl",
  mixins: [asControl],
  props: {
    position: {
      type: String,
      default: "top-right",
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
    initialState: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isActive: this.initialState,
    };
  },
  mounted() {
    this.createControl();
    this.$_addControl();
  },
  methods: {
    createControl() {
      // Create main container
      this.controlContainer = document.createElement("div");
      this.controlContainer.className =
        "mapboxgl-ctrl mapboxgl-ctrl-group fouling-toggle-control";

      // Create toggle button
      this.toggleButton = document.createElement("button");
      this.toggleButton.className = `mapboxgl-ctrl-icon fouling-toggle-button ${
        this.isActive ? "active" : ""
      }`;
      this.toggleButton.type = "button";
      this.toggleButton.title = this.isActive
        ? "Hide Fouling Status"
        : "Show Fouling Status";
      this.toggleButton.setAttribute(
        "aria-label",
        this.isActive ? "Hide Fouling Status" : "Show Fouling Status"
      );

      // Add icon - sprout for show, sprout with line for hide
      this.updateButtonIcon();

      // Add click event
      this.toggleButton.addEventListener("click", this.handleToggle);

      // Append button to container
      this.controlContainer.appendChild(this.toggleButton);

      // Set up the control
      this.control = {
        onAdd: () => this.controlContainer,
        onRemove: () => {
          if (this.controlContainer.parentNode) {
            this.controlContainer.parentNode.removeChild(this.controlContainer);
          }
        },
        getDefaultPosition: () => this.position,
      };
    },

    updateButtonIcon() {
      if (this.isActive) {
        // Sprout ON - just the sprout
        this.toggleButton.innerHTML = createSvgIcon(mapIcons.sprout);
      } else {
        // Sprout OFF - sprout with diagonal line through it
        this.toggleButton.innerHTML = createDisabledIcon(mapIcons.sprout);
      }
    },

    handleToggle(e) {
      e.preventDefault();
      this.isActive = !this.isActive;

      // Update button appearance
      this.toggleButton.classList.toggle("active", this.isActive);
      this.toggleButton.title = this.isActive
        ? "Hide Fouling Status"
        : "Show Fouling Status";
      this.toggleButton.setAttribute(
        "aria-label",
        this.isActive ? "Hide Fouling Status" : "Show Fouling Status"
      );

      // Update icon
      this.updateButtonIcon();

      // Emit the toggle event
      this.onToggle(this.isActive);
    },
  },
};
</script>

<style scoped>
.fouling-toggle-control {
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.fouling-toggle-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  color: #404040;
  transition: all 0.2s ease;
  position: relative;
}

.fouling-toggle-button:hover {
  background-color: #f0f0f0;
  color: #000;
}

.fouling-toggle-button.active {
  background-color: #0078ff;
  color: white;
}

.fouling-toggle-button.active:hover {
  background-color: #0066cc;
}

.fouling-toggle-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0078ff;
}

.fouling-toggle-button svg {
  pointer-events: none;
}

/* Add a subtle indicator when active */
.fouling-toggle-button.active::after {
  content: "";
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  background: #00ff88;
  border-radius: 50%;
  border: 1px solid white;
}
</style>
